export default __webpack_public_path__ + "static/floating-cloud-en-dd001bf6f78f28271869d6cb673aa0af.png";